import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'

import ButtonExamples from './Button/Page.js'
import Page from './Typography/Page.js'
import AppIconExamples from './AppIcon/Page.js'

export default function Page() {
  return <Container>
    {/*<Section title="Buttons"><ButtonExamples/></Section>*/}
    {/*<Section title="Typography"><TypographyExamples/></Section>*/}
    {/*<Section title="AppIcon"><AppIconExamples/></Section>*/}
  </Container>
}

function Section({ children, title }){
  return <div>
    <Typography variant="h3">{title}</Typography>
    <Box sx={{mt: 2, pl: 6}}>{children}</Box>
  </div>
}
